import { useTranslation } from 'react-i18next'
import { useSnackbar } from 'notistack'
import { ViewerMode } from 'shared/utils'
import { useIsSessionExpiryPaused } from './use-is-session-expiry-paused'
import { useSessionExpiry } from './use-session-expiry'
import { useSignOut } from './use-sign-out'

const SESSION_EXPIRED_MESSAGE_KEY_BY_VIEWER_MODE: Record<ViewerMode, string> = {
  [ViewerMode.USER]: 'sessionExpired',
  [ViewerMode.SYSTEM_ADMIN]: 'viewerMode.sessionExpired',
}

// Reads the route, so it has to be used inside the router
export const useSessionGuard = () => {
  const { t } = useTranslation('common', { useSuspense: false })
  const { enqueueSnackbar } = useSnackbar()
  const signOut = useSignOut()
  const isPaused = useIsSessionExpiryPaused()

  useSessionExpiry(mode => {
    enqueueSnackbar(t(SESSION_EXPIRED_MESSAGE_KEY_BY_VIEWER_MODE[mode]), {
      variant: 'error',
      autoHideDuration: 8000,
    })
    return signOut()
  }, isPaused)
}
